/* V9 presentation uses the existing MDMCart bridge, Shopify IDs and stock checks. */
(() => {
  'use strict';
  function init(root = document) {
    if (window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished') {
      root.querySelectorAll('[data-v9-draft]').forEach(el => { el.hidden = false; });
    }
    root.querySelectorAll('[data-v9-gallery]').forEach(gallery => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const photo = gallery.querySelector('[data-v9-photo]');
      const buttons = [...gallery.querySelectorAll('[data-v9-photo-src]')];
      function select(button) {
        photo.src = button.dataset.v9PhotoSrc;
        photo.alt = button.dataset.v9Alt;
        gallery.querySelector('[data-v9-photo-caption]').textContent = photo.alt;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const next = buttons[(index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
          select(next); next.focus();
        });
      });
      const dialog = document.querySelector('[data-v9-zoom-dialog]');
      if (dialog) {
        gallery.querySelector('[data-v9-zoom]').addEventListener('click', () => {
          dialog.querySelector('img').src = photo.src;
          dialog.querySelector('img').alt = photo.alt;
          dialog.showModal();
        });
        dialog.querySelector('[data-v9-zoom-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
    });
    root.querySelectorAll('[data-v9-form]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const copy = form.closest('.v9-product-copy');
      const button = form.querySelector('[data-v9-submit]');
      const status = form.querySelector('[data-v9-status]');
      function update() {
        const selected = form.querySelector('input[name="id"]:checked');
        const available = selected?.dataset.available === 'true';
        copy.querySelector('[data-v9-price]').textContent = selected.dataset.price;
        copy.querySelector('[data-v9-stock]').textContent = available ? 'Disponible' : 'Épuisé';
        button.disabled = !available;
        button.querySelector('span').textContent = available ? 'Ajouter au panier' : 'Épuisé';
      }
      form.addEventListener('change', event => { if (event.target.name === 'id') update(); });
      form.addEventListener('submit', async event => {
        if (!window.MDMCart) return; // Native Shopify form remains the fallback.
        event.preventDefault();
        if (button.disabled || form.dataset.busy) return;
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected || selected.disabled || selected.dataset.available !== 'true') return;
        const quantity = Number(form.elements.quantity.value);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) return;
        form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
        status.textContent = 'Ajout en cours…';
        try {
          const added = await window.MDMCart.add(selected.value, quantity);
          status.textContent = added ? 'Votre sélection a été ajoutée au panier.' : 'Ajout impossible. Vérifiez la disponibilité et la quantité.';
        } catch {
          status.textContent = 'L’ajout n’a pas abouti. Réessayez dans un instant.';
        } finally {
          delete form.dataset.busy; button.removeAttribute('aria-busy'); update();
        }
      });
    });
    root.querySelectorAll('[data-v9-copy]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const status = button.parentElement.querySelector('[data-v9-copy-status]');
        try { await navigator.clipboard.writeText(button.dataset.v9Copy); status.textContent = 'Code copié'; }
        catch { status.textContent = 'Code à saisir au paiement : ' + button.dataset.v9Copy; }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  function openAnchor() {
    if (!location.hash) return;
    const el = document.getElementById(location.hash.slice(1));
    if (el?.tagName === 'DETAILS') el.open = true;
  }
  window.addEventListener('hashchange', openAnchor); openAnchor();
})();
